export default {"src":"/_next/static/media/icon-3.c0403d00.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};